/* ==========================================================================
   Calido knowledge base

   Only the hub index category filter lives here. Everything else is either
   CSS or inline in the section that owns it: the FAQ uses native details and
   summary elements and needs no script, and the two calculators keep their
   thirty odd lines inside their own section so the maths sits next to the
   markup it drives.

   Re-initialises on Shopify's theme editor events so the filter keeps working
   while somebody is editing the section.
   ========================================================================== */

(function () {
  'use strict';

  function initHubFilters(scope) {
    var roots = (scope || document).querySelectorAll('[data-kb-hub-index]');

    Array.prototype.forEach.call(roots, function (root) {
      if (root.dataset.kbFilterReady === 'true') return;
      root.dataset.kbFilterReady = 'true';

      var buttons = root.querySelectorAll('[data-kb-filter]');
      var hubs = root.querySelectorAll('[data-kb-category]');
      var empty = root.querySelector('[data-kb-empty]');
      if (!buttons.length || !hubs.length) return;

      function apply(value) {
        var shown = 0;

        Array.prototype.forEach.call(hubs, function (hub) {
          var categories = (hub.getAttribute('data-kb-category') || '').split('|');
          var match = value === 'all' || categories.indexOf(value) !== -1;
          hub.hidden = !match;
          if (match) shown++;
        });

        Array.prototype.forEach.call(buttons, function (button) {
          var on = button.getAttribute('data-kb-filter') === value;
          button.setAttribute('aria-pressed', on ? 'true' : 'false');
        });

        if (empty) empty.hidden = shown !== 0;
      }

      Array.prototype.forEach.call(buttons, function (button) {
        button.addEventListener('click', function () {
          apply(button.getAttribute('data-kb-filter'));
        });
      });

      apply('all');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initHubFilters(); });
  } else {
    initHubFilters();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initHubFilters(event.target);
  });
})();
